import { TContentMediaConfig } from '@x/content/render/types/content-media.config';

export const CARD_GRID: TContentMediaConfig<'card', 'grid'> = {
  'card-grid': {
    '300/300': ['XS', 'SM', 'MD', 'LG', 'XL', 'XXL'],
  },
};
